import {
    useMemo,
} from 'react'

import {
    Navigate,
} from 'react-router-dom'

import {
    SkyNetRouteConfigObject, useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    ForecastDomains,
} from 'app/enums/domain.enums'

import useForecastRoutes from 'app/SkyNetRoutes/hooks/useForecastRoutes'
import ShortTermForecasts from './ShortTermForecasts'

const Forecast = () => {
    const Routes = useForecastRoutes()

    const routesConfig: SkyNetRouteConfigObject<ForecastDomains> = useMemo(() => {
        return {
            [Routes.ShortTermForecast.route]: <ShortTermForecasts />,
            [CommonRoutes.Slash]: <Navigate
                to={Routes.ShortTermForecast.route}
                replace
            />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}

export default Forecast
